import { APIClient } from "api/api_helper";
import { VOLUNTEER_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";
import { ScreeningDecisionRequest, ScreeningDeleteRequest, ScreeningInsertRequest, ScreeningSelectAllRequest, ScreeningUpdateRequest } from "modules/Volunteer/AssigningStudyModule/StudyScreening/helper/studyscreening.types";


const api = new APIClient();

export const studyscreeningApiService = {
    // SELECT ALL
    getSelectAllData: (params: ScreeningSelectAllRequest) => {
        return api.create(
            VOLUNTEER_API.STUDY_SCREENING_API + "SelectAll",
            params
        );
    },

    // INSERT
    insertData: (data: ScreeningInsertRequest) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            volunteerid: data.volunteerid,
            studyid: data.studyid,
            studyscreeningname: data.studyscreeningname,
            crfidarray: data.crfidarray || (data.crfid ? [data.crfid] : []),
            // expirydate: data.expirydate,
            createdby: user.userid,
        };
        return api.create(
            VOLUNTEER_API.STUDY_SCREENING_API + "Insert",
            payload
        );
    },

    // UPDATE
    updateData: (data: ScreeningUpdateRequest) => {
        const user = GetUserData() as CurrentUser;

        const payload: any = {
            studyid: data.studyid,
            volunteerid: data.volunteerid,
            studyscreeningid: data.studyscreeningid || data.id,
            updatedby: user.userid,
            updatereason: data.updatereason || "Updated",
        };

        // Scenario 3: CRF Data Update (JSON)
        if (data.json) {
            payload.crfid = data.crfid;
            payload.json = data.json;
        }
        // Scenario 1 & 2: Basic Info or CRF List Update
        else {
            if (data.studyscreeningname) payload.studyscreeningname = data.studyscreeningname;
            if (data.expirydate) payload.expirydate = data.expirydate;
            if (data.crfidarray) payload.crfidarray = data.crfidarray;
        }

        return api.create(
            VOLUNTEER_API.STUDY_SCREENING_API + "Update",
            payload
        );
    },

    // DELETE
    deleteData: (data: ScreeningDeleteRequest) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            studyid: data.studyid,
            volunteerid: data.volunteerid,
            studyscreeningid: data.id,
            updatereason: data.updatereason,
            updatedby: user.userid,
        };

        return api.create(
            VOLUNTEER_API.STUDY_SCREENING_API + "Delete",
            payload
        );
    },

    // UPDATE DECISION (Pass/Fail)
    updateDecision: (data: ScreeningDecisionRequest) => {
        const user = GetUserData() as CurrentUser;

        const payload = {
            assignmentstatus: data.screeningstatus,
            updatedby: user.userid,
            volunteerid: data.volunteerid,
            studyid: data.studyid,
            volunteerassignmentid: JSON.parse(localStorage.getItem("volunteerassignmentid") || "0"),
            updatereason: data.updatereason,
            reasonforunfit: data.reasonforunfit ?? null,
        };

        return api.create(
            VOLUNTEER_API.VOLUNTEER_ASSIGNMENT_API + "Update",
            payload
        );
    },
};
